import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export const FileInput = forwardRef(({ acceptedMediaTypes, onChange, disabled, ...props }, ref) => (_jsx("input", { ...props, ref: ref, hidden: true, type: "file", accept: acceptedMediaTypes?.length
        ? acceptedMediaTypes.join(", ")
        : undefined, disabled: disabled, onChange: event => {
        if (disabled) {
            return undefined;
        }
        onChange(event);
        event.currentTarget.value = null;
    } })));
FileInput.defaultProps = {
    acceptedMediaTypes: [],
    multiple: false,
};
